<template>
  <highcharts :options="chartOptions" />
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'Columns',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    chartOptions () {
      // const _self = this
      return {
        chart: {
          type: 'column',
          height: 320
        },
        title: {
          text: null
        },
        xAxis: {
          categories: this.dataChart.categories /* ['Apples', 'Oranges', 'Pears', 'Grapes', 'Bananas'] */
        },
        yAxis: {
          min: 0,
          title: {
            text: this.dataChart.metric_name
          },
          stackLabels: {
            enabled: true,
            formatter: function () {
              const total = this.total
              // Filtrar apenas as séries visíveis e calcular o total a partir delas
              const visibleSeries = this.axis.series.filter(series => series.visible)
              const grandTotal = visibleSeries.reduce((sum, series) => {
                return sum + series.yData.reduce((sum, n) => sum + n, 0)
              }, 0)
              const percentage = (total / grandTotal * 100).toFixed(1)
              return total + ' (' + percentage + '%)'
            }
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          }
        },
        series: this.dataChart.series /* [{
            name: 'John',
            data: [5, 3, 4, 7, 2]
        }, {
            name: 'Jane',
            data: [2, 2, 3, 2, 1]
        }, {
            name: 'Joe',
            data: [3, 4, 4, 2, 5]
        }] */
      }
    }
  },
  created () {
  },
  methods: {
    expand (index) {
      const filters = this.dataChart.filters[index]
      const name = this.dataChart.categories[index]
      this.$emit('expand', { filters, name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/ColumnsWithSegmentsGlobalPercent.vue